import { Box, Flex, Heading, Text } from "@chakra-ui/react";

function NotFoundPage() {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      height="100vh"
      p={4}
      bg="secondary.800"
      color="primary.100"
    >
      <Box
        p={6}
        bg="primary.700"
        borderRadius="lg"
        boxShadow="2xl"
        textAlign="center"
        minW="400px" // Adjust width as per your design needs
      >
        <Heading as="h1" size="2xl" mb={4} color="cyberpunk.pink">
          Not Found
        </Heading>
        <Text>The page you requested could not be found.</Text>
      </Box>
    </Flex>
  );
}

export default NotFoundPage;
